import {h, Fragment} from "preact"
import { useProductFilters } from "@nosto/preact"
import { useState } from "preact/hooks"

function FilterRemoveButton({ filter, className }) {
    return (
        <span className={`ns-filter-clear-selected ns-clickable ${className}`} onClick={() => filter.remove()}></span>
    )
}

export default function SelectedFilters() {
    const { filters, removeAll } = useProductFilters()
    const [active, setActive] = useState(true)

    return (
            filters.length > 0 && (
                <div class={`ns-selected-filters-wrapper ${active ? "ns-active" : ""} `}>
                    <div class="ns-filter-block-title">
                        <h3 onClick={() => {
                            setActive(!active)
                            }}>
                            <span class="ns-clickable">Refine By</span>
                        </h3>
                            <a
                            href="javascript:void(0)"
                            class="ns-text-undecorated ns-filter-clear-all"
                            onClick={() => {
                                removeAll()
                            }}
                        >
                            Clear All
                        </a>
                    </div>



                    <div class="ns-filter-list ns-d-none ns-flex-wrap ns-align-items-center">
                        {filters.map(filter => (
                            <div class="ns-selected-filter ns-justify-content-between ns-d-flex ns-align-items-center">
                                <span class="ns-color-black">
                                {filter.field == 'price' ? (
                                  <>
                                    <span style="font-weight: 400;">Price: </span>
                                    <strong>
                                    $ {
                                      filter.filter.range[0].gte !== undefined
                                        ? parseFloat(filter.filter.range[0].gte).toFixed(2)
                                        : 0
                                    } - $ {
                                      filter.filter.range[0].lte !== undefined
                                        ? parseFloat(filter.filter.range[0].lte).toFixed(2)
                                        : parseFloat(filter.value.split(' - ')[1]).toFixed(2)
                                    }
                                    </strong>
                                  </>
                                ):(
                                    <>
                                        <span style="font-weight: 400;">{filter.name}: </span><strong>{filter.value}</strong>
                                    </>
                                )}   
                                </span>
                                <FilterRemoveButton filter={filter} />
                            </div>
                        ))}
                    </div>
                    
                </div>
            
            )
    )
}
